//public routes
import NoMatch from '../components/common/404'
import Home from '../pages/home'
import Login from '../pages/login'
import Register from '../pages/register'
import ContactUs from '../pages/contact'
import Certificates from '../pages/certificates'
import AboutUs from '../pages/aboutUs'
import Forms from '../pages/forms'
import History from '../pages/history'
import TermsAndConditions from '../pages/termsAndConditions'
import FAQ from '../pages/questions'
import Announcements from '../pages/announcements'
import CryptoCurrencyNews from '../pages/cryptoNews'
import EconomicNews from '../pages/economicNews'
import InDevelopment from '../components/common/inDevelopmentPage'
import ExchangeRate from '../pages/priceList/exchangeRate'
import CoinRate from '../pages/priceList/coinRate'
import BankRate from '../pages/priceList/bankRate'
import TransferRate from '../pages/priceList/transferRate'
import CryptoCurrencyRate from '../pages/priceList/cryptoCurrenyRate'
import ChangeRate from '../pages/priceList/changeRate'
import Clock from '../pages/clock'
import NimaTransfer from '../pages/nimaTransfer'
import SanaTransfer from '../pages/sanaTransfer'
import Careers from '../pages/careers'
import Dashboard from '../pages/dashboard'
import Profile from '../pages/dashboard/profile'
import Notifications from '../pages/dashboard/notifications'
import ReserveTime from '../pages/dashboard/reserve-time'
import Transfers from '../pages/dashboard/transfer'
import TransferHistory from '../pages/dashboard/transfer/history'
import RequestNimaTransfer from '../pages/dashboard/transfer/nima'
import RequestSanaTransfer from '../pages/dashboard/transfer/sana'
import PassengerMoneyHistory from '../pages/dashboard/passenger-money'
import RequestPassengerMoney from '../pages/dashboard/passenger-money/request'

//private routes


//common routes
import LogOut from '../components/common/logOut'


const routes = [
   //common routes
    {
        path: '/logOut',
        exact: true,
        auth: true,
        component: LogOut
    },
    //public routes
    {
        path: '/',
        exact: true,
        auth: false,
        component: Home
    },
    {
        path: '/in-development',
        exact: true,
        auth: false,
        component: InDevelopment
    },
    {
        path: '/login',
        exact: true,
        auth: false,
        component: Login
    },
    {
        path: '/sign-up',
        exact: true,
        auth: false,
        component: Register
    },
    {
        path: '/world-clock',
        exact: true,
        auth: false,
        component: Clock
    },
    {
        path: '/contactUs',
        exact: true,
        auth: false,
        component: ContactUs
    },
    {
        path: '/forms',
        exact: true,
        auth: false,
        component: Forms
    },
    {
        path: '/history',
        exact: true,
        auth: false,
        component: History
    },
    {
        path: '/FAQ',
        exact: true,
        auth: false,
        component: FAQ
    },
    {
        path: '/announcements',
        exact: true,
        auth: false,
        component: Announcements
    },
    {
        path: '/economicNews',
        exact: true,
        auth: false,
        component: EconomicNews
    },
    {
        path: '/cryptoCurrencyNews',
        exact: true,
        auth: false,
        component: CryptoCurrencyNews
    },
    {
        path: '/careers',
        exact: true,
        auth: false,
        component: Careers
    },
    {
        path: '/termsAndConditions',
        exact: true,
        auth: false,
        component: TermsAndConditions
    },
    {
        path: '/certificates',
        exact: true,
        auth: false,
        component: Certificates
    },
    {
        path: '/aboutUs',
        exact: true,
        auth: false,
        component: AboutUs
    },
    {
        path: '/sana-transfer',
        exact: true,
        auth: false,
        component: SanaTransfer
    },
    {
        path: '/nima-transfer',
        exact: true,
        auth: false,
        component: NimaTransfer
    },
    {
        path: '/price-list/exchange-rate',
        exact: true,
        auth: false,
        component: ExchangeRate
    },
    {
        path: '/price-list/coin-rate',
        exact: true,
        auth: false,
        component: CoinRate
    },
    {
        path: '/price-list/transfer-rate',
        exact: true,
        auth: false,
        component: TransferRate
    },
    {
        path: '/price-list/bank-rate',
        exact: true,
        auth: false,
        component: BankRate
    },
    {
        path: '/price-list/cryptocurrency-rate',
        exact: true,
        auth: false,
        component: CryptoCurrencyRate
    },
    {
        path: '/price-list/change-rate',
        exact: true,
        auth: false,
        component: ChangeRate
    },
    //private routes
    {
        path: '/dashboard',
        exact: true,
        auth: true,
        component: Dashboard
    },
    {
        path: '/dashboard/profile',
        exact: true,
        auth: true,
        component: Profile
    },
    {
        path: '/dashboard/notifications',
        exact: true,
        auth: true,
        component: Notifications
    },
    {
        path: '/dashboard/reserve-time',
        exact: true,
        auth: true,
        component: ReserveTime
    },
    {
        path: '/dashboard/transfers',
        exact: true,
        auth: true,
        component: Transfers
    },
    {
        path: '/dashboard/transfer/request/nima',
        exact: true,
        auth: true,
        component: RequestNimaTransfer
    },
    {
        path: '/dashboard/transfer/request/sana',
        exact: true,
        auth: true,
        component: RequestSanaTransfer
    },
    {
        path: '/dashboard/transfer/request/history',
        exact: true,
        auth: true,
        component: TransferHistory
    },
    {
        path: '/dashboard/passenger-money',
        exact: true,
        auth: true,
        component: PassengerMoneyHistory
    },
    {
        path: '/dashboard/passenger-money/request',
        exact: true,
        auth: true,
        component: RequestPassengerMoney
    },
    {
        path: '',
        exact: true,
        auth: false,
        component: NoMatch
    }
    
];

export default routes;